import { render, staticRenderFns } from "./ValuesPart.vue?vue&type=template&id=66d5c808&scoped=true&"
import script from "./ValuesPart.vue?vue&type=script&lang=js&"
export * from "./ValuesPart.vue?vue&type=script&lang=js&"
import style0 from "./ValuesPart.vue?vue&type=style&index=0&id=66d5c808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d5c808",
  null
  
)

export default component.exports